<template>
  <div class="activity-floating-bubble" v-if="isShowFloatingBubble">
    <img class="activity-icon" :src="welfareIcon" alt="" @click="visible = true" />
    <div class="close-icon flex-center" @click="closeHandle">
      <van-icon name="cross" />
    </div>
  </div>
  <van-popup
    class="activity-list-modal-wrapper"
    v-model:show="visible"
    position="bottom"
    duration="0.3"
    teleport="body"
    round
    closeable
    :close-on-click-overlay="true"
  >
    <div class="modal-header flex-center">{{ welfareText }}</div>
    <div class="modal-content" :class="modalClass">
      <div class="scroll-list" v-if="chunkActivityList && chunkActivityList.length > 0">
        <div class="item-col flex-col" v-for="(items, index) in chunkActivityList" :key="index">
          <div class="item flex-center flex-col" v-for="item in items" :key="item.id" @click="goDetail(item)">
            <div class="timer-wrapper" v-if="[0, 1].includes(countdownStatusMap[item.slideshow_id]?.status)">
              <CountdownTimer
                :target-date="countdownStatusMap[item.slideshow_id]?.startTime"
                :id="item.id"
                @time-end="timeEndHandle"
                v-if="countdownStatusMap[item.slideshow_id]?.status === 0"
              />
              <span v-if="countdownStatusMap[item.slideshow_id]?.status === 1">进行中</span>
            </div>
            <img class="item-img" :src="item.pic_addr" alt="" v-if="item.pic_addr" />
            <van-icon class="null-icon" name="photo-fail" v-else />
            <div class="activity-title van-ellipsis">{{ item.link_name }}</div>
          </div>
        </div>
      </div>

      <custom-loading class="mt_100" v-show="queryLoading" />
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs, useActivityStore, useTenantStore } from '@star/stores';
import { chunk, cloneDeep, filter, find, forEach, map, some } from 'lodash-es';
import CountdownTimer from '@/components/CountdownTimer.vue';
import dayjs from 'dayjs';
import { emitter, EventEnum } from '@star/utils';
import CustomLoading from '@/components/CustomLoading.vue';
// import md5 from 'md5';
import accIcon from '/images/activity/home-activity-enter.png';

type StatusItem = {
  status: 0 | 1 | 2; // 0未开始 1进行中 2已结束
  startTime?: number; // 开始时间
  dispatchTime: Record<string, any>[]; // 红包雨配置
};

const router = useRouter();
const { isRepairing } = storeToRefs(useTenantStore());
const { getActiveActivityList, getWelfareIcons } = useActivityStore();
const chunkActivityList = ref<any[]>([]);
const activityList = ref<Record<string, any>[]>([]);
const countdownStatusMap = ref<Record<number, StatusItem>>({});
const visible = ref<boolean>(false);
const queryLoading = ref<boolean>(false);
const isShowFloatingBubble = ref<boolean>(false);
const modalClass = ref<string>();

const getActivityList = async () => {
  if (isRepairing.value) return;
  try {
    queryLoading.value = true;
    chunkActivityList.value = [];
    const res: any = await getActiveActivityList({
      state: '1',
      chan_con: 0,
      location: 0,
      num_per_page: 0,
      page_start: 1,
    });
    console.log(res, 'getActivityInfo data');
    const list = filter(
      map(
        filter(res.data, item => item.state === 1),
        (item: any) => {
          return {
            ...item,
            actionCfg: item.activity?.actionCfg ? JSON.parse(item.activity.actionCfg) : item.actionCfg,
          };
        }
      ),
      item => {
        return !item.activity || +item.activity.status !== 2;
      }
    ).sort((a, b) => a.sort_v - b.sort_v);

    const len = list.length || 0;
    getModalClass(len);
    chunkActivityList.value = chunk(list, len > 3 ? 2 : 1);
    console.log(list, 'getActivityInfo list');
    getCountdownStatusMap(list);
  } finally {
    queryLoading.value = false;
  }
};
const welfareIcon = ref<any>(null);
const welfareText = ref<any>(null);

// 获取千万福利图标
const getWelfareIcon = async () => {
  try {
    const res: any = await getWelfareIcons({
      option_code: 'HOME_TEN_MILLION_BENEFITS',
      num_per_page: 0,
      page_start: 1,
    });
    console.log('获取千万福利图标', res);
    if (res) {
      // welfareIcon.value = res
      welfareText.value = res?.value2 ? res?.value2 : '百万福利活动';
      if (res?.value) {
        welfareIcon.value = res.value;
      } else {
        welfareIcon.value = accIcon;
      }
    } else {
      welfareIcon.value = accIcon;
    }
  } catch (error) {
    console.error('获取千万福利图标失败', error);
  } finally {
  }
};

const getModalClass = (len: number) => {
  modalClass.value = `item-${len}`;
};

const getDateTime = (time: string) => {
  return `${dayjs().format('YYYY-MM-DD')} ${time}`;
};

const getCountdownStatusMap = (list: Record<string, any>) => {
  forEach(list, item => {
    if (item.activity?.activityType === '10' && item.actionCfg?.dispatchTime) {
      const result = find(item.actionCfg.dispatchTime, it => dayjs().isBefore(getDateTime(it.startTime), 'second'));
      let status = some(
        item.actionCfg.dispatchTime,
        it =>
          dayjs().isSameOrAfter(getDateTime(it.startTime), 'second') &&
          dayjs().isSameOrBefore(getDateTime(it.endTime), 'second')
      );
      countdownStatusMap.value[item.slideshow_id] = {
        status: status ? 1 : !!result ? 0 : 2,
        startTime: result ? dayjs(getDateTime(result.startTime)).valueOf() : undefined,
        dispatchTime: cloneDeep(item.actionCfg.dispatchTime),
      };
    }
  });
  console.log(countdownStatusMap.value, 'getActivityInfo countdownStatusMap');
};

const goDetail = (item: Record<string, any>) => {
  visible.value = false;
  if (item.activity?.activityType === '10') {
    if (countdownStatusMap.value?.[item.slideshow_id]?.status === 1) {
      emitter.emit(EventEnum.RED_PACKETS_RAIN, item.activity.id);
    } else {
      if (item.link === 1) {
        router.push(item.slideshow_address);
      } else {
        window.open(item.slideshow_address, '_blank');
      }
    }
  } else {
    if (item.link === 1) {
      router.push(item.slideshow_address);
    } else {
      window.open(item.slideshow_address, '_blank');
    }
  }
};

const closeHandle = () => {
  isShowFloatingBubble.value = false;
};

const timeEndHandle = (id: number) => {
  console.log(id);
  getCountdownStatusMap(filter(activityList.value, { id }));
};

watch(
  () => visible.value,
  async value => {
    if (value) {
      await getActivityList();
    } else {
      chunkActivityList.value = [];
    }
  }
);

onMounted(async () => {
  await getActivityList();
  await getWelfareIcon(); //获取千万福利图标
  isShowFloatingBubble.value = chunkActivityList.value?.length > 0;
});
</script>
<style lang="less" scoped>
.activity-floating-bubble {
  width: 226px;
  position: fixed;
  bottom: 420px;
  right: 0;
  z-index: 2000;

  .activity-icon {
    width: 100%;
  }

  .close-icon {
    width: 60px;
    height: 60px;
    position: absolute;
    top: -24px;
    right: 12px;
    z-index: 1;
    background: rgb(166 166 166 / 40%);
    border-radius: 60px;
    overflow: hidden;

    .van-icon {
      font-size: 36px;
      color: #afafaf;
    }
  }

  .van-swipe {
    width: 100%;
    height: 100%;
  }

  .img-wrapper {
    position: relative;
    margin-top: 30px;

    .activity-img {
      width: 100%;
    }
  }
}

.activity-list-modal-wrapper {
  background: #f9f9f9;
  overflow-y: hidden;
  bottom: -3px;

  .modal-header {
    height: 135px;
    background: #fff;
    font-weight: 600;
    font-size: 48px;
    color: #0a0a0a;
  }

  .modal-content {
    padding: 45px 45px 60px;
    width: 100%;
    height: 695px;
    overflow: auto hidden;
    position: relative;
    margin-bottom: 15px;

    .scroll-wrapper {
      width: 100%;
      height: 100%;
      overflow: auto hidden;
      padding-bottom: 30px;
    }

    .scroll-list {
      height: 100%;
      display: inline-flex;
      flex-direction: row;

      .item-col {
        width: 315px;
        height: 100%;
        margin-right: 45px;

        &:last-child {
          margin-right: 0;
        }

        .item {
          flex: 1;
          text-align: center;
          position: relative;
          box-shadow: 0 0 29px 0 #d2d2d24d;
          border-radius: 28px;
          background: #fff;
          padding-top: 15px;
          overflow: hidden;
          max-height: calc(50% - 18px);

          &:first-child {
            margin-bottom: 36px;
          }
        }

        .item-img {
          height: 135px;
        }

        .null-icon {
          font-size: 125px;
          color: #e1e1e1;
        }

        .activity-title {
          font-weight: 400;
          font-size: 42px;
          color: #232323;
          margin-top: 18px;
          width: 100%;
          padding: 0 30px;
        }

        .timer-wrapper {
          position: absolute;
          top: 0;
          right: 0;
          width: 174px;
          text-align: center;
          color: #fff;
          font-size: 36px;
          font-weight: 380;
          line-height: 1.4;
          background: #fa2c47;
          border-end-start-radius: 28px;
        }
      }
    }

    &.item-1,
    &.item-2,
    &.item-3 {
      height: 381px;

      .scroll-list {
        .item {
          max-height: 100%;
          margin-bottom: 0 !important;
        }
      }
    }

    &.item-4 {
      .scroll-list {
        .item-col {
          width: 495px;
        }
      }
    }

    &.item-1,
    &.item-2 {
      .scroll-list {
        .item-col {
          width: 495px;
        }
      }
    }
  }
}
</style>
